export const environment = {
    production: false,
    useMockData: true,
    keycloakBaseUrl: 'https://sso.dev.services.utimaco.com',
    keycloakRealm: 'Utimaco-Portal-DEV',
    keycloakClientId: 'TaasStorefrontFrontend',
    marketplaceRestApiBasePath: 'https://marketplace-api.dev.services.utimaco.com/api/v1',
    taasPortalFrontendUrl: 'https://portal.dev.services.utimaco.com'
};


